export const DashboardSelectors = {
    Summary: (state) => state.Dashboard.summary,
    MarketBreakdown: (state) => state.Dashboard.marketBreakdown,
    Loading: (state) => state.Dashboard.loading,
    Error: (state) => state.Dashboard.error,
};
